export class ZipCityAutocompletionEventConfig {
  name: string;
  countryField: HTMLInputElement;
  postalCodeField: HTMLInputElement;
  cityField: HTMLInputElement;
  suggestionElement: HTMLDivElement;
  suggestionListElement: HTMLDivElement;
}
